import { StaticGetEndpoints } from '../../../types/api/endpoints/staticEndpoints';
import { api } from '../api';

export const FORMATIONS_ENDPOINTS = Object.freeze({
  all: () => api.get(StaticGetEndpoints.AllFormationSessions),
});
